export default defineAppConfig({
    ui: {
      primary: 'blue',
      gray: 'slate',      
    }
  })